import { useMedia } from '../../hooks/useMedia';

export const useIsLegacyPortrait = (): boolean => {
  return useMedia(`(orientation: portrait) and (width < 1024px)`);
};
export const useIsLegacyLandscape = (): boolean => {
  return useMedia(`(orientation: landscape) and (width < 1024px)`);
};
export const useIsLegacyMinPortrait = (): boolean => {
  return useMedia(`(orientation: portrait) and (height < 551px)`);
};
export const useIsLegacyMinLandscape = (): boolean => {
  return useMedia(`(orientation: landscape) and (height < 320px)`);
};

export const useIsLegacyDesktop = (): boolean => {
  const isPortrait = useIsLegacyPortrait();
  const isLandscape = useIsLegacyLandscape();
  return !isLandscape && !isPortrait;
};
